import { CloseIcon, InfoOutlineIcon, SearchIcon } from '@chakra-ui/icons';
import { Box, Flex, Text, InputGroup, InputLeftElement, InputRightElement, Input, Spinner,List, ListItem, SkeletonText, Tooltip } from '@chakra-ui/react'
import React, { useState, useEffect, useRef } from 'react'
import { useGetApplicationsQuery, useGetAppDetailsQuery } from 'store/campaigns/adsetFormApi';

function AppNameStoreUpdate({adsAccountId, adSetFormik ={}, preFilledData, onAppChange}) {
    const inputRef = useRef(null);
    const popupRef = useRef(null);
    const [searchTerm, setSearchTerm] = useState('');
    const [debouncedSearchTerm, setDebouncedSearchTerm] = useState('');
    const [showPopup, setShowPopup] = useState(false);
    const [appOptions, setAppOptions] = useState([]);
    const [selectedAppOptions, setSelectedAppOptions] = useState({});

    const objectUrl = selectedAppOptions?.url || preFilledData?.promoted_object?.object_store_url;

    const { data: matchedApplications, isLoading: isMatchedAppLoading, isFetching, refetch } = useGetApplicationsQuery({ searchTerm: debouncedSearchTerm, adsAccountId, app_store: adSetFormik?.app_store}, { skip: !debouncedSearchTerm?.length });
    const { data: appDetails, isLoading:isAppDetailLoading } = useGetAppDetailsQuery(
        { object_url: objectUrl, adsAccountId },
        { skip: !objectUrl }
    );
   
    useEffect(() => {
        if (appDetails?.data?.length > 0) {
            onAppChange([
                {
                    id: matchedApplications && matchedApplications[0].app_id ? matchedApplications[0].app_id : appDetails?.data[0].id,
                    original_object_url: appDetails?.data[0].original_object_url,
                }
            ]);            
            setSelectedAppOptions({
                name: matchedApplications && matchedApplications[0].app_id ? matchedApplications[0].name : appDetails?.data[0]?.name,
                url: appDetails?.data[0]?.original_object_url
            })
        }
    }, [appDetails]);

    useEffect(() => {
        if (searchTerm?.length == 0) {
            setDebouncedSearchTerm('');
            setShowPopup(false);
            return;
        }

        const handler = setTimeout(() => {
            setDebouncedSearchTerm(searchTerm);
        }, 800);

        return () => {
            clearTimeout(handler);
        };
    }, [searchTerm]);

    useEffect(() => {
        if (searchTerm?.length > 0 && (searchTerm == debouncedSearchTerm)) {
            refetch()
        }
    }, [searchTerm, debouncedSearchTerm])

    useEffect(() => {
        if (matchedApplications?.length > 0) {
            setShowPopup(true);
            setAppOptions(matchedApplications);
        } else {
            setShowPopup(false);
        }
    }, [matchedApplications]);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                inputRef.current &&
                !inputRef.current.contains(event.target) &&
                popupRef.current &&
                !popupRef.current.contains(event.target)
            ) {
                setShowPopup(false);
                setAppOptions([]);
            }

        };

        document.addEventListener('mousedown', handleClickOutside);

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);


    const handleAppSelect = (app) => {
        setSelectedAppOptions(app);
        setSearchTerm('');
        setDebouncedSearchTerm('');
        setShowPopup(false);
        setAppOptions([]);
    };

    const handleAppStoreRedirect = () => {
        if (selectedAppOptions?.url) {
            window.open(selectedAppOptions?.url, '_blank');
        }
    };

  return (
    <Flex direction="column" gap={1} w={'100%'}>
        <Flex align={'center'}>
            <Text fontWeight="bold">App name</Text>
            <Box>
                <Tooltip
                    borderRadius={5}
                    label={
                        <Box fontSize="12px" p={'5px'}>
                            <Text>
                                You can advertise any app registered on Meta’s developer site. 
                            </Text>
                        </Box>
                    }
                    fontSize="md"
                >
                    <InfoOutlineIcon pointerEvents="all" ml={2} />
                </Tooltip>
            </Box>
        </Flex>
        {isAppDetailLoading ? 
            <Flex>
                <SkeletonText width="80%" noOfLines={2} skeletonHeight={2} />
            </Flex>
        :
        <Box position="relative">
            <Text fontSize={'12px'}>Choose the app you want to advertise.</Text>
            <Flex>
                <InputGroup >
                    <InputLeftElement height={'32px'}>
                        <SearchIcon boxSize={4} color='gray.500' />
                    </InputLeftElement>
                    <Input
                        ref={inputRef}
                        value={selectedAppOptions?.name ? selectedAppOptions?.name : searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        placeholder="Enter app name, app ID or exact app store URL"
                        borderRadius={'md'}
                        size={'sm'}
                        isDisabled
                        onFocus={() => {
                            setAppOptions([]);
                            if (appOptions?.length > 0) {
                                setShowPopup(true)
                            }
                        }}
                    />
                    {/* <InputRightElement height={'32px'} cursor={'pointer'}>
                        {isFetching ? (
                            <Spinner boxSize={3} />
                        ) : (<>
                            {searchTerm?.length > 0 || selectedAppOptions?.name ? (
                                <CloseIcon boxSize={3} color='gray.500' onClick={() => { setSearchTerm(''); setDebouncedSearchTerm(''); setSelectedAppOptions({}); onAppChange([]); }} />
                            ) : null}
                        </>)}
                    </InputRightElement> */}
                </InputGroup>
            </Flex>
            <Flex mt={2}>
                {showPopup && appOptions.length > 0 && (
                    <List
                        ref={popupRef}
                        position="absolute"
                        top="100%"
                        width="100%"
                        border="1px solid #ccc"
                        backgroundColor="white"
                        zIndex="1000"
                        maxHeight="200px"
                        overflowY="auto"
                    >
                        {appOptions.map((app) => (
                            <ListItem
                                key={app.unique_id * Math.random() + app.name}
                                p={'5px'}
                                px={'10px'}
                                cursor="pointer"
                                _hover={{ backgroundColor: '#f0f0f0' }}
                                onClick={() => handleAppSelect(app)}
                            >
                                 <Flex gap={2} alignItems={'center'}>
                                    <Box boxSize="24px">
                                        <img src={app?.icon_url} alt={app?.name} style={{ width: '100%', height: '100%', borderRadius: '4px' }} />
                                    </Box>
                                    <Flex direction={'column'}>
                                    <Text fontSize={'12px'}>
                                        {app.name}
                                    </Text>
                                    {app.search_source_store === 'own_apps' ? 
                                        <Text fontSize={'10px'}>
                                            {`App ID : ${app.app_id}`}
                                        </Text>
                                    :
                                        <Text fontSize={'10px'}>
                                            Not connected to your ad account
                                        </Text>
                                    }
                                    </Flex>
                                </Flex>
                            </ListItem>
                        ))}
                    </List>
                )}
            </Flex>

            {!showPopup && !selectedAppOptions?.name ?
                <Flex alignItems="center" gap={2} bg={'rgb(224,237,247)'} p={2} borderRadius={'5px'}>
                    <InfoOutlineIcon pointerEvents="all" ml={2} color={'rgb(9,120,190)'} />
                    <Text fontSize="12px" fontWeight={'bold'}>Select the app that you want people to install and use.</Text>
                </Flex>
            : 
                <Text
                    _hover={{ textDecoration: 'underline', cursor: 'pointer' }}
                    fontWeight={'normal'}
                    color={'inherit'}
                    fontSize={'10px'}
                    mt={-1}
                    onClick={handleAppStoreRedirect}
                >
                    View this app in your selected app store
                </Text>
            }
        </Box>
        }
    </Flex>
  )
}

export default AppNameStoreUpdate
